/* global axios */
import ApiClient from './ApiClient';

class MiraStaffAPI extends ApiClient {
  constructor() {
    super('mira_staff', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  chat(conversationId, text) {
    return axios.post(`${this.url}/chat`, {
      conversation_id: conversationId,
      text,
    });
  }
}

export default new MiraStaffAPI();
